import React, { useState } from "react";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import SearchBar from "../../components/SearchBar";
import salesRepresentatives_icon from "../../assets/icons/salesRepresentatives_icon.png";
import representative_icon from "../../assets/icons/representative_icon.png";
import adminWaveGraph from "../../assets/images/admin-wave-graph.png";
import adminPieChartGraph from "../../assets/images/admin-pie-chart-graph.png";
import Sidebar from "./AdminComponents/Sidebar";

const AdminDashboard = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            className="object-contain"
            alt="hamburger"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Dashboard" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Sidebar />}
        </div>
      </div>

      <div className="flex justify-start mt-8 ml-4">
        <p className="text-[18px]">Admin Dashboard</p>
      </div>

      {/* Graphs */}
      <div className="flex justify-start w-[95%] ml-4 mt-4 graphs">
        <img
          src={adminWaveGraph}
          className="object-contain w-[50%] plan--card"
          alt="admin wave graph"
        />
        <img
          src={adminPieChartGraph}
          className="object-contain w-[33%] ml-4 plan--card"
          alt="admin pie char graph"
        />
      </div>

      {/* Sales Representatives */}
      <div className="flex items-center mt-6 mb-4 ml-4">
        <img src={salesRepresentatives_icon} alt="sales representative" />
        <div>Sales Representatives</div>
      </div>

      <div className="ml-4 mb-8 flex w-[95%] justify-between create-foot">
        <div className="flex bg-[#FFF6DE] w-[23%] p-4 rounded-2xl adm-dash-card">
          <img
            src={representative_icon}
            alt="representative image"
            className="object-contain"
          />
          <div className="ml-4">
            <p className="text-[16px] font-bold">Amit Gupta</p>
            <p className="text-[12px] text-[#828282] italic">See his data</p>
          </div>
        </div>
        <div className="flex bg-[#FFF6DE] w-[23%] p-4 rounded-2xl adm-dash-card">
          <img
            src={representative_icon}
            alt="representative image"
            className="object-contain"
          />
          <div className="ml-4">
            <p className="text-[16px] font-bold">Rohit Mehta</p>
            <p className="text-[12px] text-[#828282] italic">See his data</p>
          </div>
        </div>
        <div className="flex bg-[#FFF6DE] w-[23%] p-4 rounded-2xl adm-dash-card">
          <img
            src={representative_icon}
            alt="representative image"
            className="object-contain"
          />
          <div className="ml-4">
            <p className="text-[16px] font-bold">Rahul Sharma</p>
            <p className="text-[12px] text-[#828282] italic">See his data</p>
          </div>
        </div>
        <div className="flex bg-[#FFF6DE] w-[23%] p-4 rounded-2xl adm-dash-card">
          <img
            src={representative_icon}
            alt="representative image"
            className="object-contain"
          />
          <div className="ml-4">
            <p className="text-[16px] font-bold">Ananya Ray</p>
            <p className="text-[12px] text-[#828282] italic">See his data</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
